import { JSX } from "react";
import { QHPNetwork } from "@app/overviews/network-benchmarking-dashboard/marketplace/filters";

function getNetworkTooltip(network: QHPNetwork): JSX.Element {
  const splitNetwork: string[] = network.contractId.split("_");

  if (!!splitNetwork?.length) {
    return (
      <div className="text-left">
        {network.networkName} <br />
        Issuer ID: {splitNetwork[0]} <br />
        Network ID: {splitNetwork[1]}
      </div>
    );
  }
}

export {
  getNetworkTooltip,
};
